import { createSelector } from 'reselect';

import type { ApplicationState } from '../types';

const getId = (_state: ApplicationState, id: number) => id;
const getUuid = (_state: ApplicationState, uuid: string) => uuid;

export const selectDemandApiSlice = (state: ApplicationState) =>
  state.originatorExternal.originator.demandApi;

export const selectSecondLookOfferConfigurationSlice = (
  state: ApplicationState
) => state.originatorExternal.originator.secondLookOfferConfiguration;

export const selectDemandApiRows = createSelector(
  [selectDemandApiSlice],
  ({ rows }) => rows
);

export const selectDemandApisBySubAccountUuid = createSelector(
  [getUuid, selectDemandApiSlice],
  (uuid, { byDemandSubAccountUuid }) => byDemandSubAccountUuid?.[uuid]
);

export const selectSecondLookOfferConfigurationsBySupplySubAccountId =
  createSelector(
    [getId, selectSecondLookOfferConfigurationSlice],
    (id, { bySupplySubAccountId }) => bySupplySubAccountId?.[id]
  );

export const selectCurrentSecondLookOfferConfigurationBySupplySubAccountId =
  createSelector(
    [selectSecondLookOfferConfigurationsBySupplySubAccountId],
    (secondLookOfferConfigurations) => {
      // Handles the case where the second look offer configuration is not yet loaded
      if (secondLookOfferConfigurations === undefined) {
        return undefined;
      } else if (secondLookOfferConfigurations.length === 0) {
        // Handles the case where the second look offer configuration is loaded but empty
        return null;
      } else {
        // Create a shallow copy of the array before sorting
        const sortedSecondLookOfferConfigurations = [
          ...secondLookOfferConfigurations,
        ].sort((a, b) => {
          // Assign a very old date for missing createdAt values
          const defaultDate = new Date(0); // Epoch time
          const dateA = a.createdAt ? new Date(a.createdAt) : defaultDate;
          const dateB = b.createdAt ? new Date(b.createdAt) : defaultDate;
          return dateB.getTime() - dateA.getTime();
        });
        return sortedSecondLookOfferConfigurations[0];
      }
    }
  );
